module.exports = __webpack_public_path__ + "static/media/engineering.25753a32.jpg";